export default "__VITE_ASSET__BDFjxKa0__"